<template>
  <div class="full middle:py-4 pb-6 middle:pb-0 middle:mt-4">
    <div
      v-if="load"
      class="w-full h-full bg-blue-800/50 inset-0 fixed z-50 flex items-center justify-center"
    >
      <div class="bg-white p-8 rounded shadow-lg m-8">
        <p>Upload en cours merci de patienter ...</p>
      </div>
    </div>
    <div
      v-if="load"
      class="fixed bg-red-900/70 h-full w-full flex justify-center items-center inset-0 z-50"
    >
      <div class="bg-white p-8 rounded shadow-lg m-8">
        Upload en cours merci de patienter ...
      </div>
    </div>
    <h2 class="title middle:block font-bold hidden">
      TÉLÉCHARGEZ VOS TICKETS DE CAISSE
    </h2>

    <section class="w-full mt-4 flex flex-wrap items-center">
      <div class="w-full">
        <vue-dropzone
          :useCustomSlot="true"
          ref="myVueDropzone"
          id="dropzone"
          :options="dropzoneOptions"
          @vdropzone-file-added="added"
          @vdropzone-removed-file="removed"
        >
          <div class="dropzone-custom-content">
            <p>
              <i
                class="fa-solid text-3xl text-gray-400 fa-cloud-arrow-down"
              ></i>
            </p>
            <h3 class="dropzone-custom-title text-gray-700">
              Faites glisser et déposez pour télécharger votre facture!
            </h3>
            <div class="subtitle text-sm">
              ..ou cliquez pour sélectionner un fichier sur votre ordinateur
            </div>
          </div></vue-dropzone
        >
      </div>
      <div v-if="upldoadButton" class="w-full text-center my-6">
        <button
          @click="upldoadFile"
          class="button uppercase font-semibold bg-red-700 text-white"
        >
          <i class="fa-regular fa-floppy-disk mr-1"></i>
          <span class="inline-bloc pt-2 ml-2">Valider</span>
        </button>
      </div>
    </section>
    <p class="text-sm bg-yellow-50 mt-4 p-3 text-yellow-700 rounded">
      <strong>Attention :</strong><br />Vous ne pouvez déposer qu'un seul ticket
      de caisse à la fois. Si vous déposez un document qui fusionne l'ensemble
      des tickets de caisse, votre participation ne pourra être traitée (formats
      acceptés : PDF, PNG, JPG. Poids maximum 5 Mo).
    </p>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import axios from "axios";

export default {
  name: "app",
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    createLineItemFormId: {
      type: String,
    },
    subid: {
      type: String,
    },
    uid: {
      type: String,
    },
    formid: {
      type: String,
    },
    upload_form: {
      type: Boolean,
    },
  },
  data: function () {
    return {
      server: "https://api-gabarit.promo.dev",
      load: false,
      hiderror: true,
      files: [],
      openForm: false,
      upldoadButton: false,
      document: null,
      dropzoneOptions: {
        url: "non",
        autoProcessQueue: false,
        paramName: "file",
        addRemoveLinks: true,
        autoQueue: false,
        maxFiles: 4,
        acceptedFiles: ".pdf,.jpg,.jpeg,.png",
      },
    };
  },
  methods: {
    async removed(file) {
      this.files = this.files.filter((f) => f.name !== file.name);
      if (this.files.length === 0) {
        this.upldoadButton = false;
      }
    },
    getResultForm(result) {
      if (result) {
        this.load = false;
        this.openForm = false;
        window.location.reload();
      }
    },
    async added(file) {
      const name = file.name;
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const file = await e.target.result;
          this.files.push({ data: file, name: name });
          this.upldoadButton = true;
        } catch (error) {
          console.error(error);
        }
      };
      reader.readAsDataURL(file);
    },
    viewError() {
      this.load = false;
    },
    loading() {
      this.load = true;
    },
    async upldoadFile() {
      try {
        this.load = true;

        Object.keys(this.files).forEach(async (key) => {
          await axios.put(
            `https://api-gabarit.promo.dev/api/v2/submissions/${this.createLineItemFormId}`,
            {
              id_proof: this.files[key].data,
              parentSubmissionId: this.subid,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        });
        this.$refs.myVueDropzone.removeAllFiles(true);
        this.load = false;
        this.files = [];
        this.$emit("uploaded");

        return;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style>
#dropzone {
  border: dashed 2px #d1d1d1 !important;
}

.dz-progress {
  display: none;
}
</style>
